import api from "../api/axios";
import { getEmployeeTimeZoneDate } from "../utils/getEmployeeTimeZoneDate";
import Cookies from "js-cookie";
import { getAuthToken } from "../utils/tokenStorage";

export const getAllCompanies = async (queryParams) => {
  try {
    const response = await api.get(`api/companies?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching companies:", error);
    throw error;
  }
};

export const getEmployer = async (officalEmail) => {
  try {
    const response = await api.post(`auth/validate-email`, {
      email: officalEmail,
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching multipleCompany:", error);
    throw error;
  }
};

const punchDate = getEmployeeTimeZoneDate();

export const switchCompany = async (employeeId) => {
  try {
    const token = getAuthToken();
    if(!token) {
      throw new Error("Try to Login again!");
    }
    const response = await api.post(
      `auth/login`,
      { 
        employee_id: employeeId, 
        punchDate: punchDate,
        token
      },
      { withCredentials: true }
    );
    const { user } = response.data;
    const sessionDuration = response.data.sessionDuration;
    const refreshTokenExpiry = Date.now() + sessionDuration;
    Cookies.set("refreshTokenExpiry", `${refreshTokenExpiry}`, {
      secure: true,
      sameSite: "None",
      path: "/",
      expires: sessionDuration / (1000 * 60 * 60 * 24),
    });
    localStorage.setItem("refreshToken", response.data.refreshToken);
    localStorage.setItem("refreshTokenExpiry", refreshTokenExpiry);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("colorschema", user.company.colour);
    localStorage.setItem("companyColor", user.company.colour);
    localStorage.setItem("companyName", user.company.name);
    localStorage.setItem("employee_role", user?.employee_role);
    window.location.assign("/");
  } catch (error) {
    console.error("Error during switch company", error.message);
  }
};

export const getCompanyProbationConfig = async (companyId) => {
  try {
    const response = await api.get(`api/company-probation-config/${companyId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching company probation config:", error);
    throw error;
  }
};
